import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row justify--center" }
const _hoisted_2 = { class: "item" }

import { WritePermissionsByRoute } from "@/codes/types/PermissionsByRoute";
import { VUEX_ACTIONS } from "@/codes/util/constants";
import router from "@/router";
import store from "@/store";
import { getCurrentInstance, onMounted, ref, watch } from "vue-demi";
import { useRoute } from "vue-router";



export default /*#__PURE__*/_defineComponent({
  props: {
  pageCount: {
    type: Number,
    required: true
  },
  visiblePages: {
    type: Number,
    default: 5
  },
  currentRoute: {
    type: String,
    required: true
  },
  pageLoaded: {
    type: Number,
    required: true
  },
  showDelete: {
    type: Boolean,
    default: true
  },
  showNew: {
    type: Boolean,
    default: true
  },
  hasFilter: {
    type: Boolean,
    default: false
  }
},
  emits: [ 'pageChanged', 'doNew', 'doDelete' ],
  setup(__props) {

const props = __props


const page = ref(1);
const emit = getCurrentInstance()?.emit;



watch(page, (value: number) => {
  router.push({ query: { 'page': value } });
});

const hasWritePermission = ref(false);

const checkHasWritePermission = function() {
  const writePermissions = WritePermissionsByRoute[props.currentRoute];
  if (writePermissions && writePermissions.length > 0 && store.getters.hasPermissions(writePermissions)) {
    hasWritePermission.value = true;
  } else {
    hasWritePermission.value = false;
  }
}

onMounted(() => {
  store.subscribeAction({
    after: (action) => {
      if (action.type === VUEX_ACTIONS.setUserInfo) {
        checkHasWritePermission();
      }
    }
  });

  checkHasWritePermission();
})

const route = useRoute();
watch(route, () => {
  if (route.name?.toString() === props.currentRoute) {
    const newPage = route.query && route.query.page ? parseInt(route.query.page.toString()) : 1;
    if (newPage !== props.pageLoaded) {
      page.value = newPage;
      if (emit) {
        emit('pageChanged', newPage);
      }
    }
  }
});

const doNew = function() {
  //verificar se tem permissão para o novo
  if (emit) {
    emit('doNew');
  }
};

const doDelete = function() {
  //verificar se tem permissão para excluir
  if (emit) {
    emit('doDelete');
  }
};


return (_ctx: any,_cache: any) => {
  const _component_va_navbar_item = _resolveComponent("va-navbar-item")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_navbar = _resolveComponent("va-navbar")!
  const _component_va_card_title = _resolveComponent("va-card-title")!
  const _component_va_pagination = _resolveComponent("va-pagination")!
  const _component_va_card_content = _resolveComponent("va-card-content")!
  const _component_va_card = _resolveComponent("va-card")!

  return (_openBlock(), _createBlock(_component_va_card, {
    class: _normalizeClass(["base-list", { 'has-filter': __props.hasFilter }])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_va_card_title, { class: "flex xs12 pa-0" }, {
        default: _withCtx(() => [
          _createVNode(_component_va_navbar, {
            color: "info",
            shape: "",
            class: "mb-2"
          }, {
            left: _withCtx(() => [
              _createVNode(_component_va_navbar_item, null, {
                default: _withCtx(() => [
                  _createElementVNode("h3", {
                    class: "display-3",
                    style: _normalizeStyle({
                'color': 'var(--va-white)',
              })
                  }, _toDisplayString(_ctx.$t(`menu.${__props.currentRoute}`)), 5)
                ]),
                _: 1
              })
            ]),
            right: _withCtx(() => [
              _renderSlot(_ctx.$slots, "navbarItems"),
              (hasWritePermission.value && __props.showNew)
                ? (_openBlock(), _createBlock(_component_va_navbar_item, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_va_button, {
                        color: "success",
                        onClick: doNew
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('form.new')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_va_navbar_item, null, {
                default: _withCtx(() => [
                  (hasWritePermission.value && __props.showDelete)
                    ? (_openBlock(), _createBlock(_component_va_button, {
                        key: 0,
                        color: "danger",
                        onClick: doDelete
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('form.delete')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 3
          })
        ]),
        _: 3
      }),
      _createVNode(_component_va_card_content, { class: "px-0" }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default"),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_va_pagination, {
                modelValue: page.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (page.value = $event)),
                pages: __props.pageCount,
                "visible-pages": __props.visiblePages,
                size: 'small'
              }, null, 8, ["modelValue", "pages", "visible-pages"])
            ])
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})